import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useRouter } from 'next/router'
import { GroupHorizontalMenuMobile } from 'SRC/modules/categories/components'
import { FilterButtons } from 'SRC/modules/layout/Header/components/FilterButtons'
import { FilterButtons as FilterButtonsVehicleParts } from 'SRC/modules/vehicleParts/list/components'
import { getCurrentGroup } from 'SRC/modules/groups/selectors'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'

const GroupsMenuMobile = ({
  filtersCount,
  vehiclePartsGroup,
  vehiclePartsFilterValues,
  vehiclePartsCategory
}) => {
  const router = useRouter()

  return (
    <React.Fragment>
      {!['/vehicleParts', '/vehiclePartsSearch'].includes(router.pathname) ? <FilterButtons /> : <FilterButtonsVehicleParts filtersCount={filtersCount} />}

      <div className='kategorije'>
        <GroupHorizontalMenuMobile
          vehiclePartsGroup={vehiclePartsGroup}
          vehiclePartsFilterValues={vehiclePartsFilterValues}
          vehiclePartsCategory={vehiclePartsCategory}
        />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    currentGroup: getCurrentGroup(state),
    currentSubcategory: getCurrentSubCategory(state)
  }
}

GroupsMenuMobile.defaultProps = {
  groups: []
}

GroupsMenuMobile.propTypes = {
  currentGroup: PropTypes.shape({
    categories: PropTypes.array,
    seo: PropTypes.string
  }),
  filtersCount: PropTypes.number.isRequired,
  isAdPage: PropTypes.bool.isRequired,
  currentSubcategory: PropTypes.object,
  router: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  vehiclePartsCategory: PropTypes.string
}


export default connect(mapStateToProps)(GroupsMenuMobile)
